<!--
  AnotherRubberPendant
  其他挂件
-->


<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="挂件 > 橡胶挂件 > 其他挂件" name="其他挂件">
        <el-row>
          <el-col :span="24">
            <el-form
              :label-position="labelPosition"
              :model="anotherRubberPendant"
              label-width="80px"
            >
              <el-form-item label="描述">
                <el-input type="textarea" v-model="anotherRubberPendant['描述']"></el-input>
              </el-form-item>
              <el-form-item label="类型">
                <el-select v-model="anotherRubberPendant['类型']" placeholder="请选择类型">
                  <el-option label="国厂" value="国厂"></el-option>
                  <el-option label="日厂" value="日厂"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="尺寸">
                <el-row type="flex" class="row-bg">
                  <el-col :span="12">
                    <el-input v-model="anotherRubberPendant['尺寸宽']" placeholder="宽 cm"></el-input>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-input v-model="anotherRubberPendant['尺寸长']" placeholder="长 cm"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="款式">
                <el-input v-model="anotherRubberPendant['款式']" placeholder="请填写您选择的款式"></el-input>
              </el-form-item>
              <el-form-item label="数量" :inline="true">
                <el-input-number
                  v-model="anotherRubberPendant['数量']"
                  :min="100"
                  :max="10000"
                  label="数量"
                ></el-input-number>
                <el-alert title="起订量：日厂200个，国厂1个" type="info" show-icon class='el-alert__title' style="padding: 8px 16px; margin: 20px 0 0 0;"></el-alert>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button> <el-button v-on:click="clear()">清空</el-button> 
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "AnotherRubberPendant",
  data() {
    return {
      forcollapse: ['allsame'],
      anotherRubberPendant: {
        title: "其他挂件"
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.anotherRubberPendant);
       
    },
    clear() {
      this.$root.clearAlert()
      this.anotherRubberPendant = {
        title: "其他挂件"
      };
    }
  }
};
</script>
<style scoped>
</style>